import EventEmitter from 'node:events';
import type { EnhancedFeatureInterface, FeatureInterface } from 'unleash-client/lib/feature';
import type { RepositoryInterface } from 'unleash-client/lib/repository';
import type { Segment } from 'unleash-client/lib/strategy/strategy';

export class WaipuUnleashRepository extends EventEmitter implements RepositoryInterface {
  private data: FeatureInterface[];

  constructor(data: FeatureInterface[]) {
    super();
    this.data = data;
  }

  // biome-ignore lint/suspicious/noEmptyBlockStatements: required by RepositoryInterface, no-op for static data
  async start() {}
  // biome-ignore lint/suspicious/noEmptyBlockStatements: required by RepositoryInterface, no-op for static data
  stop() {}

  getToggles(): FeatureInterface[] {
    return this.data;
  }

  getTogglesWithSegmentData(): EnhancedFeatureInterface[] {
    return this.data.map((toggle) => ({
      ...toggle,
      segments: [],
      strategies: (toggle.strategies ?? []).map((s) => ({ ...s, segments: [] })),
    }));
  }

  getToggle(name: string): FeatureInterface | undefined {
    return this.data.find((toggle) => toggle.name === name);
  }

  getSegment(_id: number): Segment | undefined {
    return undefined;
  }
}
